exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-tabs[data-v-2fbc9e64]{margin-bottom:15px}.nav-tabs .active a[data-v-2fbc9e64]{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.tab-content[data-v-2fbc9e64]{border:1px solid #ddd;border-top:none;padding:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2fbc9e64","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/ocean-insights/DetailsTab.vue
// module id = 1478
// module chunks = 0